import { render, staticRenderFns } from "./WorkBoxLayout.vue?vue&type=template&id=6b4001d6&scoped=true"
import script from "./WorkBoxLayout.vue?vue&type=script&lang=js"
export * from "./WorkBoxLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkBoxLayout.vue?vue&type=style&index=0&id=6b4001d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4001d6",
  null
  
)

export default component.exports